import React from 'react';
import { connect } from 'react-redux';
import NavItem from './item';

const Nav = props => {
  const style = {
    display: 'flex',
  }
  return (
    <div style={style}>
      <NavItem screen='catalog' screenDescr='Каталог' />
      <NavItem screen='orders' screenDescr='Заказы' />
      <NavItem screen='messages' screenDescr='Сообщения' />
      {/* <NavItem screen='sandbox' screenDescr='Песочница' /> */}
    </div>
  );
}

export default connect()(Nav);



// WEBPACK FOOTER //
// ./src/components/layout/header/nav/index.js